<template>
	<div class="mx-auto px-4 sm:px-6 lg:px-8">
		<!-- Content goes here -->
		<slot></slot>
	</div>
</template>